// Shared native-install capture: one listener for the whole app.
let deferred = null;
const listeners = new Set();

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferred = e;
    listeners.forEach((fn) => fn(e));
  });
}

export function onInstallAvailable(fn) {
  listeners.add(fn);
  if (deferred) fn(deferred);
  return () => listeners.delete(fn);
}

export async function promptInstall() {
  if (!deferred) return "unavailable";
  deferred.prompt(); // browser's native installer — one tap
  const { outcome } = await deferred.userChoice;
  deferred = null;
  return outcome; // "accepted" | "dismissed"
}

export function isAppInstalled() {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}
